import * as React from "react";

export default () => {
  return <div>Åtkomst som nyckelinnehavare ska ha</div>;
};
